<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="lang-icon" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu
      class="w-48 i18n-dropdown vx-navbar-dropdown"
    >
      <vs-dropdown-item @click="updateLocale('en_US')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en_US.png" alt="en" /> &nbsp;English</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('zh_CN')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/zh_CN.png" alt="fr" /> &nbsp;中文简体</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('zh_Hant')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/zh_CN.png" alt="fr" /> &nbsp;中文繁體</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Cookies from 'js-cookie'
export default {
  computed: {
    ...mapGetters(['userInfo','agentRole','language','listRefresh']),
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
    },
    getCurrentLocaleData() {
        const locale = this.$i18n.locale;
        if (locale == "en_US")      return { flag: "en", lang: 'English'    }
        else if (locale == "zh_CN") return { flag: "cn", lang: '中文简体' }
        else if (locale == "zh_Hant") return { flag: "hant", lang: '中文繁體' }
    },
  },
  created(){
    //最高优先级的语言  用户选择之后尽量保留用户习惯
    const  UserSelecLang = Cookies.get('language');
    //console.log("UserSelecLang",UserSelecLang);
    if(UserSelecLang){
      this.updateTheDefaultLanguage(UserSelecLang);
      return;
    }
    const defaultLanguage = this.getDefaultLanguage();
    //console.log("默认语言:", defaultLanguage); // 输出类似 "en-US" 或 "zh-CN"
    // 使用 switch case 判断语言类型
    switch (defaultLanguage) {
        case 'zh-CN':
            this.updateTheDefaultLanguage("zh_CN");
            break;
        case 'zh-TW':
            this.updateTheDefaultLanguage("zh_Hant");
            break;
        case 'zh-HK':
            this.updateTheDefaultLanguage("zh_Hant");
            break;
        default:
            this.updateTheDefaultLanguage("en_US");
            break;
    }
  },
  methods: {
    getDefaultLanguage(){
      // 尝试从 navigator.languages 获取首选语言
      if (navigator.languages && navigator.languages.length) {
          return navigator.languages[0];
      }
      // 否则回退到 navigator.language 或 navigator.userLanguage
      return navigator.language || navigator.userLanguage;
    },
    updateTheDefaultLanguage(locale){
      this.$i18n.locale = locale;
      Cookies.set('language', locale,{ expires: 365 });
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      // this.$store.dispatch('setLanguage', language);
      // 查询弹框信息
      localStorage.setItem('isReadedCustomerInfo','');
      localStorage.setItem('isReadedAgentInfo','');
      Cookies.set('language', locale,{ expires: 365 });
      window.location.reload();
    },
  }
}
</script>
<style lang="scss">
  .lang-icon {
    width: 2.14rem;
    height: 1.24rem;
  }
</style>
